export enum AnalysisMissingValueStrategy {
  NEAREST_EARLIER = 'NEAREST_EARLIER',
  SKIP_MONTH = 'SKIP_MONTH',
}
